<script setup lang="ts">
  import { type ComputedRef, inject, type Ref, ref } from 'vue';
import type { RouteLocationRaw } from 'vue-router';
  const seeAllConversationsRoute = inject<ComputedRef<RouteLocationRaw>>(
    'seeAllConversationsRoute'
  )!;
  const unReadConversation: Ref<number> = inject('unReadConversation', ref(0));
  const conversationIconColor: Ref<string> = inject('conversationIconColor', ref('#2a7de1'));
  const showThreadIcon: Ref<boolean> = inject('showThreadIcon', ref(true));

</script>

<template>
  <router-link v-if="showThreadIcon"
    :to="seeAllConversationsRoute"
    aria-label="cart"
    class="text-none pe-2 d-flex "
  >
    <v-badge
      v-if="unReadConversation"
      :color="
        unReadConversation && unReadConversation > 0 ? 'red' : 'transparent'
      "
      max="9"
      :content="unReadConversation"
      rounded="rounded"
      dir="ltr"
    >
    <svg width="24" height="23" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.3327 5.8335L10.8402 10.606C10.5859 10.7537 10.2971 10.8315 10.0031 10.8315C9.70907 10.8315 9.42027 10.7537 9.16602 10.606L1.66602 5.8335" :stroke="conversationIconColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M16.666 3.3335H3.33268C2.41221 3.3335 1.66602 4.07969 1.66602 5.00016V15.0002C1.66602 15.9206 2.41221 16.6668 3.33268 16.6668H16.666C17.5865 16.6668 18.3327 15.9206 18.3327 15.0002V5.00016C18.3327 4.07969 17.5865 3.3335 16.666 3.3335Z" :stroke="conversationIconColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


</v-badge>
       <svg v-else  width="24" height="23" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.3327 5.8335L10.8402 10.606C10.5859 10.7537 10.2971 10.8315 10.0031 10.8315C9.70907 10.8315 9.42027 10.7537 9.16602 10.606L1.66602 5.8335" :stroke="conversationIconColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M16.666 3.3335H3.33268C2.41221 3.3335 1.66602 4.07969 1.66602 5.00016V15.0002C1.66602 15.9206 2.41221 16.6668 3.33268 16.6668H16.666C17.5865 16.6668 18.3327 15.9206 18.3327 15.0002V5.00016C18.3327 4.07969 17.5865 3.3335 16.666 3.3335Z" :stroke="conversationIconColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

  </router-link>
</template>
<style lang="scss">
  .thread-count {
    position: absolute;
    top: -5px;
    right: -10px;
    border-radius: 100%;
    background-color: #05dbf2;
    width: 16px;
    height: 16px;
    font-size: 12px;
    color: white;
  }
  .fill-icon {
    fill: $black-600;
  }
</style>
